import searchSliceFactory from 'shared/utils/search-slice-factory';

export const { searchSlice, Search, useSearchQuery } = searchSliceFactory({
  prefix: 'technical-subjects',
});
